import { createFileRoute } from '@tanstack/react-router';
import { PageContainer } from '@/components/shared/PageContainer';
import { queryClient } from '@/lib/utils/queryClient';
import { FiberSettingsTable } from '../-components/FiberSettingsTable';
import { adminFiberSettingsQueryOptions } from '../-hooks/useAdminFiberSettings';
import { useFiberSettingsPage } from '../-hooks/useFiberSettingsPage';

export const Route = createFileRoute('/management/fiber-settings/(pages)/')({
  // No `validateSearch`: the route takes no parameters, so there is no paging,
  // sort or filter state to carry in the URL — the table does all three over
  // the one response it is given.
  //
  // The prefetch's rejection is swallowed on purpose: letting it reject hands
  // the route to the router's error boundary, which replaces the page and hides
  // the table's own "could not load" banner. The component's `useQuery` hits
  // the same failure and surfaces it inline.
  loader: () =>
    queryClient
      .ensureQueryData(adminFiberSettingsQueryOptions())
      .catch(() => undefined),
  component: FiberSettingsPage,
});

function FiberSettingsPage() {
  const page = useFiberSettingsPage();

  return (
    <PageContainer>
      <FiberSettingsTable page={page} />
    </PageContainer>
  );
}
